// IbaPayout.js (Modified useEffect section)

import React, { useState, useEffect } from 'react';
import '../ibaPayout/ibapayout.scss';
import { toast } from 'react-toastify';

const IbaPayout = ({ selectedAgent, onUpdateAgentPayout }) => {

   console.log(selectedAgent, "selectedAgentpayout");  

    // if (!payoutStructureData) return <div>Loading payout structure...</div>;

    return (
        <div className="payout-structure-card">
            <div className="left-section">
                <div className="section-title-iba"><span>Payout Structure</span></div>
                <div className='section-wrapper agent-sec-wrapper'>
                    <div className='bonus-sec'>
                        <div className="form-group-l">
                            <label>Level:</label>
                            <span className="value">{selectedAgent?.PayoutStructure?.Tier}</span>
                            
                        </div>

                        <div className="form-group-l">
                            <label>New Tier Bonus:</label>
                            <span className="value">{selectedAgent?.PayoutStructure?.TierBonus}</span>
                           
                        </div>
                    </div>

                    <div className="divider payout-div"></div>
                        <div className="bonus-sec">
                            <div className="form-group-l">
                                <label>Per Minute:</label>
                                <span className="value">{selectedAgent?.PayoutStructure?.PerMin}</span>
                               
                            </div>

                            <div className="form-group-l">
                                <label>Per Account:</label>
                                <span className="value">{selectedAgent?.PayoutStructure?.PerAccount}</span>
                                
                            </div>
                        </div>
                </div>
            </div>
        </div>
    );
};

export default IbaPayout;